<template>
  <div class="row">
    <!-- Image -->
    <template v-if="images.length || uploadingImages.length">
      <div class="col-md-12">
        <strong>
          {{ $t('message.images') }} ({{ images.length }})
        </strong>
      </div>
      <div class="col-md-12 mt-2">
        <ul class="images">
          <li
            v-for="(file, index) in uploadingImages"
            :key="`uploading-${index}`"
          >
            <div class="loading-image">
              <i class="fas fa-spinner spin"/>
            </div>
          </li>
          <li
            v-for="(file, index) in images"
            :key="index"
          >
            <span class="drop-shadow"/>
            <img
              :src="file.file_source"
              @click="openImage(file.file_source)"
            >
            <button
              v-if="hasRoleDelete"
              @click="handleDelete(index, file)"
            >
              <i class="fas fa-trash"/>
            </button>
          </li>
        </ul>
      </div>
    </template>
    <!-- PDF -->
    <template v-if="otherFiles.length || uploadingOtherFiles.length">
      <div class="col-md-12 mt-3">
        <strong>
          {{ $t('message.files') }} ({{ otherFiles.length }})
        </strong>
      </div>
      <div class="col-md-12 mt-2">
        <ul class="files">
          <li
            v-for="(file, index) in uploadingOtherFiles"
            :key="`uploading-${index}`"
            style="display: flex; justify-content: unset;align-items: center;gap: 12px;"
          >
            <i class="fas fa-spinner spin"/>
            {{ $t('message.uploading') }}
            "{{ file.file_name }}"
          </li>
          <li
            v-for="(file, index) in otherFiles"
            :key="index"
          >
            <a
              :href="file.file_source"
              target="_blank"
            >
              {{ file.file_name }}
            </a>
            <button
              v-if="hasRoleDelete"
              @click="handleDelete(index, file)"
            >
              <i class="fas fa-trash"/>
            </button>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="!(images.length || uploadingImages.length) && !(otherFiles.length || uploadingOtherFiles.length)">
      <div class="col-12">-</div>
    </template>
    <div
      v-if="showCreateButton && hasRoleCreate"
      class="col-md-12 mt-2"
    >
      <button
        class="btn btn-light btn-create upload-file"
      >
        + {{ createButtonText }}
        <input
          ref="inputFile"
          type="file"
          @change="handleFileChange"
        >
      </button>
    </div>
  </div>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  props: {
    images: {
      type: Array,
      default: () => ([]),
    },
    otherFiles: {
      type: Array,
      default: () => ([]),
    },
    uploadingImages: {
      type: Array,
      default: () => ([]),
    },
    uploadingOtherFiles: {
      type: Array,
      default: () => ([]),
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    createButtonText: {
      type: String,
      default: true,
    },
  },

  mixins: [userPermissionMixin],

  methods: {
    resetInputFile() {
      this.$refs.inputFile.type = 'text'
      this.$refs.inputFile.type = 'file'
    },
    handleFileChange(e) {
      this.$emit('onUploadFile', e.target.files[0])
      this.resetInputFile()
    },
    handleDelete(index, file) {
      this.$emit('onDelete', index, file)
    },
    openImage(fileSource) {
      window.open(fileSource)
    },
  },
}
</script>

<style scoped>
ul.images {
  display: flex;
  gap: 8px;
  margin: 0;
  width: 100%;
  overflow-x: auto;
}
ul.images li {
  position: relative;
}
ul.images li .drop-shadow {
  width: 100%;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6026509287925697) 100%);
  z-index: 1;
}
ul.images li img {
  height: 95px;
  cursor: pointer;
}
ul.images li .loading-image {
  width: 95px;
  height: 95px;
  background: #eee;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
}
ul.images li button {
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  outline: none;
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 2;
}

ul.files {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
ul.files li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}
ul.files li a {
  width: 80%;
}
ul.files li button {
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  outline: none;
  color: #D4D4D4;
  cursor: pointer;
}
button.upload-file {
  position: relative;
}
button.upload-file input[type="file"] {
  opacity: 0;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSectionDocRefFile.vue